export default __webpack_public_path__ + "static/media/Component50–1.7c5c06e5.svg";